import React, { useState } from "react";
import FaqData from "react-faq-component";
import Secheader from "./common/Secondaryheader";
import faqData from "../data/faqData";

const Faq = () => {
  const [rows, setRowsOption] = useState(null);

  const formattedData = faqData.map((faq) => ({
    title: faq.question,
    content: faq.answer,
  }));

  const data = {
    rows: formattedData, // Use the imported faqData array
  };

  return (
    <>
      <Secheader
        sectitle="FAQs"
        secdesc="Discover solutions to common queries about Byteskull Technologies, our products, and innovation."
      />

      <section>
        <div className="container row py-5 m-auto">
          <div className="container mx-auto py-5 col-lg-10 col-xl-9 text-center">
            <h2 className="section-title">Frequently Asked Questions?</h2>
            <div className="faq-style-wrapper mt-8">
              {/* Pass the 'faqData' array directly to the FaqData component */}
              <FaqData
                data={data}
                getRowOptions={setRowsOption}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
